/* global lozad */ // tUrl等のグローバル変数を宣言する

import './_smoothScroll.js' // スムーズスクロール
// import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accordionBtn = 'spmenu' // このIDを基準としたアコーディオン
  $('#' + accordionBtn + '-open,#' + accordionBtn + '-close').on(
    'click',
    function() {
      $('#' + accordionBtn + ',#' + accordionBtn + '-open').toggleClass(
        'active'
      )
      $('body').toggleClass('lock')
    }
  )

  $('.js-accordion').on('click', function() {
    // アコーディオンメニュー
    $(this)
      .toggleClass('active')
      .next()
      .slideToggle()
  })

  lozad('.lozad,.chain', {
    rootMargin: '5%',
    loaded: function(el) {
      el.classList.add('active') // 画面に交差した要素をactive
    }
  }).observe()

  function trunk8() {
    $('.js-t8').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
    $('.js-t8.line2').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
  }
  trunk8()
  $(window).on('load resize ', function() {
    trunk8()
  })
})
